import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ResponseModel } from '../../domain/authentication.model'
import { LocalStorageShoppingCart } from '../cart.service'
import { CoreEnvironmentService } from '../core-environment.service'
import { WidgetContextService } from '../widget/widget-context.service'
import { SHOPPING_CART_APP_TYPE } from './shopping-cart.enum'

@Injectable({ providedIn: 'root' })
export class ShoppingCartService {
  private readonly coreEnvironmentService = inject(CoreEnvironmentService)
  private readonly widgetContextService = inject(WidgetContextService)

  private readonly http = inject(HttpClient)
  private readonly appType = inject(SHOPPING_CART_APP_TYPE)

  private readonly baseUrl = this.coreEnvironmentService.getBeatmakerApiBaseUrl()
  private readonly httpOptions = { withCredentials: true }

  getShoppingCart(): Observable<LocalStorageShoppingCart[]> {
    return this.http.get<LocalStorageShoppingCart[]>(
      `${this.baseUrl}/api/shopping-cart?appType=${this.appType}`,
      this.httpOptions
    )
  }

  updateShoppingCart(beats: LocalStorageShoppingCart[]): Observable<ResponseModel> {
    return this.http.put<ResponseModel>(
      `${this.baseUrl}/api/shopping-cart?appType=${this.appType}`,
      beats,
      this.httpOptions
    )
  }

  getWidgetShoppingCart(): Observable<LocalStorageShoppingCart[]> {
    const widgetId = this.widgetContextService.getWidgetId()
    return this.http.get<LocalStorageShoppingCart[]>(
      `${this.baseUrl}/api/widgets/${widgetId}/shopping-cart`,
      this.httpOptions
    )
  }

  updateWidgetShoppingCart(beats: LocalStorageShoppingCart[]): Observable<ResponseModel> {
    const widgetId = this.widgetContextService.getWidgetId()
    return this.http.put<ResponseModel>(
      `${this.baseUrl}/api/widgets/${widgetId}/shopping-cart`,
      beats,
      this.httpOptions
    )
  }
}
